<template>
    <div class="IdSearchResult">
        <!-- s: header -->
        <header id="header-slidePanel">
            <h2>아이디 찾기</h2>
            <div class="btn_back">
                <a @click="slidePanelClose">
                  <img src="@/assets/images/btn_back.png" width="50" alt="이전" />
                </a>
            </div>
        </header>
        <!-- e: header -->
        <!-- s: contents -->
        <div class="contents-area-slidePanel">
            <!-- 회원정보가 없을 경우 -->
            <template v-if="result == null || result.length==0">
                <div class="padding-50">
                    <img src="@/assets/images/find_search_no.png" width="100%" />
                </div>
                <p class="info-msg mrg-btm-40">
                  입력하신 정보와 일치하는 아이디가 없습니다.<br/>
                  정보 확인 후, 다시 시도해 주세요.
                </p>
                <button class="btn-big btn-bule"
                        @click.prevent="slidePanelClose">
                  다른 방법으로 아이디 찾기
                </button>
            </template>
            <!-- 회원정보가 있을 경우 -->
            <template v-else>
                <h2 class="slidePanel-title">입력하신 정보와 일치하는 아이디 목록입니다. </h2>
                <ul class="li-bottom-line">
                    <li v-for="data in result" :key="data.strUserId">
                        <span>
                            <label class="rad">
                                <input type="radio"
                                       :value="data.strUserId"
                                       v-model="selectSearchId" />
                                <i></i>
                                <strong>{{ data.strUserId | idHidden }}</strong>
                                <span class="pull-right">
                                  가입일: {{ data.strCreated }}
                                </span>
                            </label>
                        </span>
                    </li>
                </ul>
                <div class="mrg-top-50">
                    <button class="btn-big btn-bule"
                            @click.prevent="loginMoveFunc">
                      로그인 하기
                    </button>
                </div>
                <div class="mrg-top-10">
                    <button class="btn-big btn-white"
                            @click.prevent="pwFindSlideView">
                      비밀번호 찾기
                    </button>
                </div>
            </template>
        </div>
        <!-- e: contents -->
    </div>
</template>

<script>
export default {
    name: 'IdSearchResult',
    props: ['pResult'],
    data() {
        return {
            result:[],            // 검색결과
            selectSearchId:'',    // 검색된 아이디 선택(아이디가 여러개 검색될 경우)
        }
    },
    filters: {
        // 일부 아이디 히든처리
        idHidden:function (str){
            return str.substring(0,str.length-4)+'****';
        }
    },
    // $el 생성전
    created(){
    },
    // $el 생성후
    mounted() {
        window.callbackBackKey = this.callbackBackKey;
        this.result = this.pResult;
    },
    methods: {
        // APP 뒤로가기
        callbackBackKey(){
            this.slidePanelClose();
        },
        // 로그인 화면 이동
        loginMoveFunc(){
            if (!this.selectSearchId){
                this.toastMsg('아이디를 선택해 주세요.',1500);
                return false;
            }

            let param = {};
            param.result = 'close';
            param.userId = this.selectSearchId;

            this.slidePanelClose(param);
        },
        // 비밀번호 찾기
        pwFindSlideView(){
            let props = {
                pStrUserId : this.selectSearchId,
            };
            const panel =this.$showPanel({
                component: () => import('./PwSearch.vue'),
                props: props,
                openOn: 'right',
                width:screen.width,
            });
            panel.promise.then(result => {
                window.callbackBackKey = this.callbackBackKey;
                if (result.result === "close"){
                    this.slidePanelClose(result);
                }
            });
        }
    }
}
</script>

<style scoped>
</style>
